//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { setMapConfig } from '@/reducks/setting';
import MapActionButton from './map-action';

/**
 * レイアウト切替ボタン
 * (地図アクションバーの縦並びと横並びを変更)
 */
export default function MapActionLayout(props) {

  // 地図動作設定
  const mapConfig = useSelector((state) => state.setting.mapConfig);
  const dispatch = useDispatch();
  const vertical = mapConfig.vertical;

  // レイアウト切替ボタン処理 - レイアウトをストアに保存
  const handleClick = React.useCallback(() => {
    dispatch(setMapConfig({
      vertical: !vertical,
    }));
  }, [vertical]);

  //
  // 描画
  //
  return (
    <MapActionButton
      icon={vertical ? 'maximize' : 'dock-left'}
      text={vertical ? 'ボタンを上に表示' : 'ボタンを左に表示'}
      title={vertical
          ? 'ボタンを地図の上側に表示します。'
          : 'ボタンを地図の左側に表示します。'
      }
      onClick={handleClick}
      {...props}
    />
  );
}
